import React from 'react';

import ChatPanel from '../components/ChatPanel';
import '../App.css';

// The AEO Assistant on its own page (/chat), for using it in a separate tab or window. The same chat as the panel
// on the analysis page, sized to fill the page.
const ChatView = ()=>{
	return (
		<main className="view-container chat-main">
			<ChatPanel />
		</main>
	);
};

export default ChatView;
